function togglePasswordVisibility() {
  const passwordInput = document.getElementById('password');
  if (passwordInput.type == 'password') {
    passwordInput.setAttribute('type', 'text');
  } else {
    passwordInput.setAttribute('type', 'password');
  }
}

function displayIdleNotice() {
  popsss.flashWarning(
    'Your session was ended due to inactivity',
    1000 * 60 * 60 * 72,
  );
}

$(document).ready(function () {
  $('#show-password-button').on('click', togglePasswordVisibility);
  if (window.was_idle) {
    displayIdleNotice();
  }
});
